export const messages = {
  en: {
    transactionLogManage: {
      queryCondition: 'Query Conditions',
      inputTransactionId: 'Please enter transaction ID',
      inputAppId: 'Please enter app code',
      inputServiceCode: 'Please enter service code',
      query: 'Query',
      reset: 'Reset',
      transactionLog: 'Transaction Log',
      transactionId: 'Transaction ID',
      srcIp: 'Source IP',
      appId: 'App Code',
      serviceCode: 'Service Code',
      costTime: 'Time Cost',
      state: 'Status',
      failed: 'Failed',
      success: 'Success',
      createTime: 'Request Time',
      operation: 'Operation',
      viewMessage: 'View Message'
    },
    transactionLogMessage: {
      logMessage: 'Log Message',
      requestHeader: 'Request Header',
      requestMessage: 'Request Message',
      responseHeader: 'Response Header',
      responseMessage: 'Response Message',
      cancel: 'Cancel'
    }
  },
  zh: {
    transactionLogManage: {
      queryCondition: '查询条件',
      inputTransactionId: '请输入流水',
      inputAppId: '请输入应用编码',
      inputServiceCode: '请输入服务编码',
      query: '查询',
      reset: '重置',
      transactionLog: '交互日志',
      transactionId: '流水',
      srcIp: '源IP',
      appId: '应用编码',
      serviceCode: '服务编码',
      costTime: '耗时',
      state: '状态',
      failed: '失败',
      success: '成功',
      createTime: '请求时间',
      operation: '操作',
      viewMessage: '查看报文'
    },
    transactionLogMessage: {
      logMessage: '日志报文',
      requestHeader: '请求头',
      requestMessage: '请求报文',
      responseHeader: '返回头',
      responseMessage: '返回报文',
      cancel: '取消'
    }
  }
}